import React from 'react';
import { 
    HeartIcon, 
    UserGroupIcon, 
    BuildingOffice2Icon,
    AcademicCapIcon,
    ShieldCheckIcon,
    SparklesIcon,
    TrophyIcon,
    ClockIcon
} from '@heroicons/react/24/outline';
import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';

const AboutUs = () => {
    const stats = [
        { 
            icon: BuildingOffice2Icon, 
            number: '70+', 
            label: 'ศูนย์บริการทั่วประเทศ',
            color: 'from-blue-600 to-blue-700'
        },
        { 
            icon: UserGroupIcon, 
            number: '5,000+', 
            label: 'ผู้ป่วยที่ได้รับการดูแล',
            color: 'from-orange-600 to-orange-700'
        },
        { 
            icon: ClockIcon, 
            number: '20+', 
            label: 'ปีแห่งประสบการณ์',
            color: 'from-green-600 to-green-700'
        },
        { 
            icon: TrophyIcon, 
            number: 'HA', 
            label: 'มาตรฐาน HA Certified',
            color: 'from-purple-600 to-purple-700'
        }
    ];

    const values = [
        {
            icon: HeartIcon,
            title: 'วัตถุประสงค์ (Purpose)',
            description: 'เราจะสร้างคุณภาพชีวิตที่ดีให้ผู้ป่วยโรคไต ที่รักษาด้วยการฟอกเลือดด้วยเครื่องไตเทียม',
            gradient: 'from-rose-500 to-pink-500',
            details: [
                'ดูแลผู้ป่วยด้วยความเอาใจใส่',
                'มุ่งเน้นคุณภาพชีวิตที่ดีขึ้น',
                'บริการที่ครอบคลุมทุกความต้องการ'
            ]
        },
        {
            icon: UserGroupIcon,
            title: 'ค่านิยมหลัก (Core Value)',
            description: 'We Before Me - เราทำงานเป็นทีม เพื่อผู้ป่วยเป็นศูนย์กลาง',
            gradient: 'from-orange-500 to-amber-500',
            details: [
                '💪 We Can - เราทำได้',
                '❤️ We Care - เราใส่ใจ',
                '🤝 We Love - เรารักและเคารพ',
                '😊 We Happy - เราสร้างความสุข'
            ]
        },
        {
            icon: AcademicCapIcon,
            title: 'ความเชี่ยวชาญหลัก (Core Competency)',
            description: 'เชี่ยวชาญด้านการดูแลรักษาผู้ป่วยฟอกเลือดด้วยเครื่องไตเทียม ดูแลดุจญาติมิตร',
            gradient: 'from-indigo-500 to-purple-500',
            details: [
                'ทีมแพทย์และพยาบาลผู้เชี่ยวชาญ',
                'เทคโนโลยีทางการแพทย์ที่ทันสมัย',
                'มาตรฐาน HA Certified'
            ]
        },
        {
            icon: BuildingOffice2Icon,
            title: 'พันธกิจ (Mission)',
            description: 'มุ่งมั่นพัฒนาการบริการให้มีคุณภาพและสร้างความประทับใจ',
            gradient: 'from-blue-500 to-cyan-500',
            details: [
                'เพิ่มมาตรฐานการรักษาที่มีคุณภาพ',
                'สร้างความประทับใจในการให้บริการ',
                'ดูแลผู้ป่วยแบบองค์รวม'
            ]
        }
    ];

    const milestones = [
        {
            year: '2010',
            title: 'ก่อตั้งศูนย์ฟอกไตแห่งแรก',
            description: 'เริ่มต้นด้วยศูนย์บริการแห่งแรกในกรุงเทพมหานคร'
        },
        {
            year: '2015',
            title: 'ขยายสู่ภูมิภาค',
            description: 'เปิดศูนย์บริการครอบคลุม 4 ภูมิภาคทั่วประเทศ'
        },
        {
            year: '2020',
            title: 'รับรองมาตรฐาน HA',
            description: 'ได้รับการรับรองมาตรฐานโรงพยาบาลระดับสากล'
        },
        {
            year: '2026',
            title: 'ผู้นำด้านการฟอกไต',
            description: 'มีศูนย์บริการกว่า 70 แห่งทั่วประเทศ'
        }
    ];

    const team = [
        {
            role: 'แพทย์เฉพาะทางด้านไตเทียม',
            description: 'ผู้เชี่ยวชาญด้านโรคไตและการฟอกเลือด วินิจฉัยและวางแผนการรักษา',
            icon: '👨‍⚕️'
        },
        {
            role: 'พยาบาลผู้เชี่ยวชาญไตเทียม',
            description: 'ผู้เชี่ยวชาญระดับสูงด้านการฟอกไต ดูแลและควบคุมคุณภาพการรักษา',
            icon: '👩‍⚕️'
        },
        {
            role: 'พยาบาลไตเทียม',
            description: 'ให้การดูแลผู้ป่วยระหว่างการฟอกไต ติดตามอาการและประเมินผล',
            icon: '👩‍⚕️'
        },
        {
            role: 'พนักงานผู้ช่วยพยาบาลไตเทียม',
            description: 'ช่วยเหลือการดูแลผู้ป่วย เตรียมอุปกรณ์',
            icon: '👩‍⚕️'
        }
    ];

    return (
        <>
            <Navbar />
            <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
                
                {/* Hero Section */}
                <section className="relative overflow-hidden bg-gradient-to-br from-blue-900 via-blue-800 to-slate-900 text-white">
                    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE0YzMuMzEgMCA2IDIuNjkgNiA2cy0yLjY5IDYtNiA2LTYtMi42OS02LTYgMi42OS02IDYtNnpNNiAzNGMzLjMxIDAgNiAyLjY5IDYgNnMtMi42OSA2LTYgNi02LTIuNjktNi02IDIuNjktNiA2LTZ6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-30"></div>
                    
                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
                        <div className="text-center space-y-6 md:space-y-8">
                            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
                                <SparklesIcon className="w-4 h-4 text-orange-400" />
                                <span className="text-sm font-bold text-orange-300">ผู้นำด้านการฟอกไตในประเทศไทย</span>
                            </div>
                            
                            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tight">
                                เกี่ยวกับ<span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">เรา</span>
                            </h1>
                            
                            <p className="text-lg md:text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed font-medium">
                                เราคือเครือข่ายศูนย์บริการฟอกไตที่ใหญ่ที่สุดในประเทศไทย มุ่งมั่นให้บริการด้วยมาตรฐานสากล 
                                และความใส่ใจในทุกรายละเอียด เพื่อคุณภาพชีวิตที่ดีของผู้ป่วยโรคไต
                            </p>

                            <div className="flex flex-wrap justify-center gap-4 pt-4">
                                <a href="#values" className="px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold rounded-2xl hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-xl shadow-orange-500/30 hover:shadow-2xl hover:shadow-orange-500/40 hover:-translate-y-1">
                                    ค่านิยมของเรา
                                </a>
                                <a href="#team" className="px-8 py-4 bg-white/10 backdrop-blur-md text-white font-bold rounded-2xl border-2 border-white/30 hover:bg-white/20 transition-all duration-300 hover:-translate-y-1">
                                    ทีมงานของเรา
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Wave Divider */}
                    <div className="absolute bottom-0 left-0 right-0">
                        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
                            <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="rgb(248 250 252)"/>
                        </svg>
                    </div>
                </section>

                {/* Stats Section */}
                <section className="py-12 md:py-16 -mt-1">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                            {stats.map((stat, index) => (
                                <div 
                                    key={index}
                                    className="group relative bg-white rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-slate-100"
                                >
                                    <div className={`absolute inset-0 bg-gradient-to-br ${stat.color} opacity-0 group-hover:opacity-5 rounded-3xl transition-opacity duration-500`}></div>
                                    
                                    <div className="relative space-y-4">
                                        <div className={`w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-gradient-to-br ${stat.color} flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-500`}>
                                            <stat.icon className="w-6 h-6 md:w-7 md:h-7 text-white" strokeWidth={2} />
                                        </div>
                                        
                                        <div>
                                            <div className="text-3xl md:text-4xl font-black text-slate-900 mb-2">
                                                {stat.number}
                                            </div>
                                            <div className="text-sm md:text-base font-bold text-slate-600">
                                                {stat.label}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Values Section */}
                <section id="values" className="py-16 md:py-24 bg-gradient-to-br from-white to-slate-50">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center mb-12 md:mb-16 space-y-4">
                            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-50 rounded-full border border-orange-200">
                                <HeartIcon className="w-4 h-4 text-orange-600" />
                                <span className="text-sm font-black text-orange-600 uppercase tracking-wider">Our Values</span>
                            </div>
                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900">
                                ค่านิยมของเรา
                            </h2>
                            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                                หลักการที่เรายึดมั่นในการให้บริการดูแลผู้ป่วยทุกท่าน
                            </p>
                        </div>

                        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
                            {values.map((value, index) => (
                                <div
                                    key={index}
                                    className="group relative bg-white rounded-3xl p-8 md:p-10 shadow-lg hover:shadow-2xl transition-all duration-500 border border-slate-100 overflow-hidden"
                                >
                                    <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${value.gradient} opacity-5 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-700`}></div>
                                    
                                    <div className="relative space-y-4">
                                        <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${value.gradient} flex items-center justify-center shadow-xl group-hover:scale-110 group-hover:rotate-6 transition-all duration-500`}>
                                            <value.icon className="w-8 h-8 text-white" strokeWidth={2} />
                                        </div>
                                        
                                        <h3 className="text-2xl font-black text-slate-900">
                                            {value.title}
                                        </h3>
                                        
                                        <p className="text-slate-600 leading-relaxed mb-4">
                                            {value.description}
                                        </p>

                                        {/* Details List */}
                                        {value.details && (
                                            <ul className="space-y-2 pt-4 border-t border-slate-100">
                                                {value.details.map((detail, idx) => (
                                                    <li key={idx} className="flex items-start gap-2 text-sm text-slate-700">
                                                        <span className="text-orange-500 mt-0.5">✓</span>
                                                        <span>{detail}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Timeline Section */}
                {/* <section className="py-16 md:py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white relative overflow-hidden">
                    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wMyI+PHBhdGggZD0iTTM2IDE0YzMuMzEgMCA2IDIuNjkgNiA2cy0yLjY5IDYtNiA2LTYtMi42OS02LTYgMi42OS02IDYtNnpNNiAzNGMzLjMxIDAgNiAyLjY5IDYgNnMtMi42OSA2LTYgNi02LTIuNjktNi02IDIuNjktNiA2LTZ6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-50"></div>
                    
                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center mb-12 md:mb-16 space-y-4">
                            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
                                <ClockIcon className="w-4 h-4 text-orange-400" />
                                <span className="text-sm font-black text-orange-300 uppercase tracking-wider">Our Journey</span>
                            </div>
                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black">
                                เส้นทางของเรา
                            </h2>
                            <p className="text-lg text-blue-200 max-w-2xl mx-auto">
                                ก้าวสำคัญในการพัฒนาและขยายบริการเพื่อผู้ป่วย
                            </p>
                        </div>

                        <div className="relative">

                            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-orange-500 via-blue-500 to-orange-500 transform -translate-x-1/2"></div>
                            
                            <div className="space-y-12 md:space-y-16">
                                {milestones.map((milestone, index) => (
                                    <div 
                                        key={index}
                                        className={`relative flex flex-col md:flex-row items-center gap-6 md:gap-8 ${
                                            index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                                        }`}
                                    >
                                    
                                        <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                                            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-105">
                                                <div className="text-orange-400 text-sm font-black uppercase tracking-wider mb-2">
                                                    {milestone.year}
                                                </div>
                                                <h3 className="text-xl md:text-2xl font-black mb-3">
                                                    {milestone.title}
                                                </h3>
                                                <p className="text-blue-200">
                                                    {milestone.description}
                                                </p>
                                            </div>
                                        </div>

                                     
                                        <div className="hidden md:flex w-2/12 justify-center">
                                            <div className="w-6 h-6 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 border-4 border-slate-900 shadow-xl shadow-orange-500/50 z-10"></div>
                                        </div>

                                        
                                        <div className="hidden md:block w-5/12"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section> */}

                {/* Team Section */}
                <section id="team" className="py-16 md:py-24 bg-gradient-to-br from-white to-blue-50">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center mb-12 md:mb-16 space-y-4">
                            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 rounded-full border border-blue-200">
                                <UserGroupIcon className="w-4 h-4 text-blue-600" />
                                <span className="text-sm font-black text-blue-600 uppercase tracking-wider">Our Team</span>
                            </div>
                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900">
                                ทีมงานมืออาชีพ
                            </h2>
                            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                                ผู้เชี่ยวชาญที่พร้อมดูแลคุณด้วยความเอาใจใส่
                            </p>
                        </div>

                        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                            {team.map((member, index) => (
                                <div 
                                    key={index}
                                    className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-slate-100 text-center"
                                >
                                    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-orange-500/5 opacity-0 group-hover:opacity-100 rounded-3xl transition-opacity duration-500"></div>
                                    
                                    <div className="relative space-y-4">
                                        <div className="text-6xl mb-4 group-hover:scale-110 transition-transform duration-500">
                                            {member.icon}
                                        </div>
                                        
                                        <h3 className="text-xl font-black text-slate-900">
                                            {member.role}
                                        </h3>
                                        
                                        <p className="text-sm text-slate-600 leading-relaxed">
                                            {member.description}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="py-16 md:py-24 bg-gradient-to-br from-orange-500 via-orange-600 to-orange-700 text-white relative overflow-hidden">
                    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMTRjMy4zMSAwIDYgMi42OSA2IDZzLTIuNjkgNi02IDYtNi0yLjY5LTYtNiAyLjY5LTYgNi02ek02IDM0YzMuMzEgMCA2IDIuNjkgNiA2cy0yLjY5IDYtNiA2LTYtMi42OS02LTYgMi42OS02IDYtNnoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
                    
                    <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-8">
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-black">
                            พร้อมให้บริการคุณแล้ววันนี้
                        </h2>
                        
                        <p className="text-lg md:text-xl text-orange-100 max-w-2xl mx-auto leading-relaxed">
                            ติดต่อเราเพื่อขอคำปรึกษาหรือนัดหมายการรักษา ทีมงานของเราพร้อมดูแลคุณด้วยความเอาใจใส่
                        </p>

                        <div className="flex flex-wrap justify-center gap-4 pt-4">
                            <a href="/hemodialysisUnit" className="px-8 py-4 bg-white text-orange-600 font-bold rounded-2xl hover:bg-orange-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1">
                                ค้นหาศูนย์บริการ
                            </a>
                            {/* <a href="tel:0811506992" className="px-8 py-4 bg-orange-700/50 backdrop-blur-md text-white font-bold rounded-2xl border-2 border-white/30 hover:bg-orange-700/70 transition-all duration-300 hover:-translate-y-1">
                                โทร. 081-150-6992
                            </a> */}
                        </div>
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default AboutUs;
